// https://minntgmbh.atlassian.net/wiki/spaces/BROT/pages/3751215124/BSB+Enums

export enum ErrorTypeEnum {
    ERROR_INVALID_TOKEN = 'ERROR_INVALID_TOKEN',
    ERROR_WRONG_LOGIN_CREDENTIALS = 'ERROR_WRONG_LOGIN_CREDENTIALS',
    ERROR_REFRESH_TOKEN_EXPIRED = 'ERROR_REFRESH_TOKEN_EXPIRED',
    ERROR_ACCOUNT_NOT_ACTIVE = 'ERROR_ACCOUNT_NOT_ACTIVE',
    ERROR_2FA_REQUIRED = 'ERROR_2FA_REQUIRED',
    ERROR_2FA_INVALID = 'ERROR_2FA_INVALID',
    ERROR_2FA_EXPIRED = 'ERROR_2FA_EXPIRED',
    ERROR_DEVICE_CONFIRMATION_REQUIRED = 'ERROR_DEVICE_CONFIRMATION_REQUIRED',
    ERROR_DEVICE_SESSION_CONFIRMATION_PENDING = 'ERROR_DEVICE_SESSION_CONFIRMATION_PENDING',
    ERROR_DEVICE_SESSION_REJECTED = 'ERROR_DEVICE_SESSION_REJECTED',
    ERROR_SOMETHING_WENT_WRONG_WITH_3RD_PARTY_API_CALL = 'ERROR_SOMETHING_WENT_WRONG_WITH_3RD_PARTY_API_CALL',
    ERROR_3RD_PARTY_API_UNAUTHORIZED = 'ERROR_3RD_PARTY_API_UNAUTHORIZED',
    ERROR_INVALID_PASSWORD_VERIFICATION_HASH = 'ERROR_INVALID_PASSWORD_VERIFICATION_HASH',
    ERROR_MIGRATED_USER_SET_NEW_PASSWORD = 'ERROR_MIGRATED_USER_SET_NEW_PASSWORD',
    ERROR_MISSING_APPLICATION_TYPE_HEADER = 'ERROR_MISSING_APPLICATION_TYPE_HEADER',
    ERROR_UNAUTHORIZED_APPLICATION_ACCESS = 'ERROR_UNAUTHORIZED_APPLICATION_ACCESS',

    ERROR_NO_REQUIRED_PERMISSIONS = 'ERROR_NO_REQUIRED_PERMISSIONS',


}
